var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8161 4H5.18048C4.5292 4 4 4.51676 4 5.15381V18.8461C4 19.4831 4.5292 20.0005 5.18048 20.0005H18.8161C19.4689 20.0005 19.9999 19.4831 19.9999 18.8461V5.15381C19.9999 4.51676 19.4689 4 18.8161 4Z",
    fill: "#0A66C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81348 6.1626C8.55849 6.1626 9.16386 6.76797 9.16386 7.51415C9.16386 8.25945 8.55849 8.86483 7.81348 8.86483C7.06701 8.86483 6.46338 8.25945 6.46338 7.51415C6.46338 6.76797 7.06701 6.1626 7.81348 6.1626ZM6.64853 17.3858H8.97898V9.88916H6.64853V17.3858Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4399 9.88926H12.6747V10.9144H12.7067C13.0177 10.3247 13.7778 9.70337 14.9112 9.70337C17.2704 9.70337 17.7059 11.2556 17.7059 13.2742V17.3859H15.3769V13.74C15.3769 12.8705 15.3621 11.7522 14.1662 11.7522C12.9537 11.7522 12.7689 12.7 12.7689 13.6777V17.3859H10.4399V9.88926Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinColor);
export default __webpack_public_path__ + "static/media/linkedin-color.4c6253bea7dcf7d289fa94c45d62fe51.svg";
export { ForwardRef as ReactComponent };